module.exports = __webpack_public_path__ + "static/media/tt_commons_bold-webfont.dd8c2df5.woff";